module.exports = __webpack_public_path__ + "img/titel.ad02e645.jpg";